"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _text_input = require("../../text_input");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var ConfirmEmailInput = function ConfirmEmailInput(_ref) {
  var register = _ref.register,
    errors = _ref.errors,
    emailInputValue = _ref.emailInputValue,
    disablePaste = _ref.disablePaste;
  var error = false;
  var helperText = '';
  if (errors.emailConfirmation) {
    error = true;
    helperText = errors.emailConfirmation.message;
  }
  var checkEmail = function checkEmail(confirmEmailValue) {
    if (emailInputValue === confirmEmailValue) {
      return true;
    } else {
      return 'Please enter the same email again.';
    }
  };
  var onPaste = function onPaste(event) {
    if (disablePaste) {
      event.preventDefault();
    }
    return false;
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_text_input.TextInput, {
    type: "email",
    label: "Confirm email address",
    name: "emailConfirmation",
    helperText: helperText,
    error: error,
    onPaste: onPaste,
    register: register({
      required: 'Please confirm your email',
      validate: {
        sameEmail: function sameEmail(value) {
          return checkEmail(value);
        }
      }
    }),
    cypressClass: "confirm-email"
  }));
};
ConfirmEmailInput.propTypes = {
  /**
   * Object containing the errors from this input field.
   */
  errors: _propTypes["default"].object,
  /**
   * Will determine whether to disable or enable copy paste
   */
  disablePaste: _propTypes["default"].bool,
  /**
   *
   * The email value to check against for validation when confirming email
   */
  emailInputValue: _propTypes["default"].string,
  /**
   * A function that gets passed for the useForm hook from react-hook-form to register an input
   *
   */
  register: _propTypes["default"].func.isRequired
};
ConfirmEmailInput.defaultProps = {
  errors: {},
  emailInputValue: '',
  disablePaste: true,
  register: function register() {}
};
var _default = exports["default"] = ConfirmEmailInput;